/** @format */
import { ReactNode } from 'react';

export type Breadcrumb = {
    children?: ReactNode;
    href?: string;
    size?: 'small' | 'medium' | 'large' | 'inherit';
    templatePath?: string;
    variant?: 'default' | 'custom';
};

export enum TaxonomyTermType {
    CATEGORY = 'Category',
    BRAND = 'Brand',
}
